(function () {
  function init() {
    var bar = document.querySelector('[data-arc-sticky]');
    if (!bar || bar.dataset.ready) return;
    var form = document.querySelector('product-form form[id^="product-form-"]');
    if (!form) return;
    var mainBtn = form.querySelector('[name="add"]');
    if (!mainBtn) return;
    bar.dataset.ready = 'true';

    var btn = bar.querySelector('[data-arc-sticky-btn]');
    var priceSlot = bar.querySelector('[data-arc-sticky-price]');
    var mainPrice = document.querySelector('[id^="price-template"]');

    function syncPrice() {
      if (!mainPrice || !priceSlot) return;
      var current = mainPrice.querySelector('.price__container');
      if (current) priceSlot.innerHTML = current.outerHTML;
    }

    function syncState() {
      btn.disabled = mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true';
      var label = mainBtn.querySelector('span');
      if (btn.disabled && label) btn.textContent = label.textContent.trim();
      else if (!btn.disabled) btn.textContent = btn.dataset.label;
    }

    btn.dataset.label = btn.textContent.trim();
    syncPrice();
    syncState();

    if (mainPrice) new MutationObserver(syncPrice).observe(mainPrice, { childList: true, subtree: true });
    new MutationObserver(syncState).observe(mainBtn, { attributes: true, childList: true, subtree: true });

    function show(visible) {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      btn.tabIndex = visible ? 0 : -1;
      document.body.classList.toggle('arc-sticky-open', visible);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        show(!e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(mainBtn);
    }

    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else mainBtn.click();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
